module.exports = __webpack_public_path__ + "static/media/icon-arrow-blue.5f732fd5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon-arrow-blue.svg
// module id = 263
// module chunks = 3